module.exports = __webpack_public_path__ + "img/education.56ed3a30.png";